/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { OverlayViewF } from "@react-google-maps/api";
import { MapNodeType } from "client";
import { Const } from "const";
import { FC } from "react";
import { convertLatLngFromGeolocation } from "utils/Map";
import { ReactComponent as IconTimer } from "assets/icon_timer.svg";

interface Props {
  nodes: MapNodeType[];
}
export const AutoStartNodeMapOverlay: FC<Props> = ({ nodes }: Props) => {
  return (
    <>
      {nodes.map((node, idx) => {
        return (
          <OverlayViewF
            key={`autostart-overlay-${idx}`}
            position={convertLatLngFromGeolocation(node.geolocation)}
            getPixelPositionOffset={(w, h) => {
              return { x: -(w / 2), y: -(h / 2) };
            }}
            mapPaneName="overlayMouseTarget"
            zIndex={Const.zIndex.autoStart}
          >
            <IconTimer />
          </OverlayViewF>
        );
      })}
    </>
  );
};
